var map = {
	"./discord.svg": [
		"b09b",
		"chunk-2d20e8cd"
	],
	"./facebook.svg": [
		"c73c",
		"chunk-2d2176ba"
	],
	"./instagram.svg": [
		"780a",
		"chunk-2d0d79c8"
	],
	"./telegram.svg": [
		"492c",
		"chunk-2d0c20ac"
	],
	"./twitter.svg": [
		"2080",
		"chunk-2d0b16ac"
	],
	"./viber.svg": [
		"4f44",
		"chunk-2d0cc9a8"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "fcf7";
module.exports = webpackAsyncContext;